import styled from '@emotion/styled';
import { Radio } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

export const FilterRadioContainer = styled.div`
  padding: 8px;
`;

export const FilterRadioButton = styled(Radio)`
  display: block;
  height: 30px;
  line-height: 30px;
`;

export const FilterSearchContainer = styled.div`
  padding: 8px;
  display: flex;
  justify-content: space-between;
`;

export const SearchIcon = styled(SearchOutlined)`
  color: ${props => (props.isFiltered ? props.theme.color.primary : '#AAA')};
`;
